import { Components } from 'react-markdown';

export const convertHtmlToMarkdown = (content: string): string => {
    return content
        .replace(/<strong>(.*?)<\/strong>/g, '**$1**')
        .replace(/<em>(.*?)<\/em>/g, '*$1*')
        .replace(/<b>(.*?)<\/b>/g, '**$1**')
        .replace(/<i>(.*?)<\/i>/g, '*$1*')
        .replace(/<u>(.*?)<\/u>/g, '__$1__')
        .replace(/<h1>(.*?)<\/h1>/g, '# $1')
        .replace(/<h2>(.*?)<\/h2>/g, '## $1')
        .replace(/<h3>(.*?)<\/h3>/g, '### $1')
        .replace(/<ul>/g, '')
        .replace(/<\/ul>/g, '')
        .replace(/<ol>/g, '')
        .replace(/<\/ol>/g, '')
        .replace(/<li>(.*?)<\/li>/g, '- $1')
        .replace(/<br\s*\/?>/g, '\n')
        .replace(/<p>(.*?)<\/p>/g, '$1\n\n')
        .replace(/<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/g, '[$2]($1)')
        .replace(/<code>(.*?)<\/code>/g, '`$1`');
};

export const markdownComponents: Components = {
    strong: ({ children }) => (
        <strong style={{ fontWeight: '700' }}>{children}</strong>
    ),
    em: ({ children }) => (
        <em style={{ fontStyle: 'italic' }}>{children}</em>
    ),
    h1: ({ children }) => (
        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>{children}</h1>
    ),
    h2: ({ children }) => (
        <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>{children}</h2>
    ),
    h3: ({ children }) => (
        <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>{children}</h3>
    ),
    ul: ({ children }) => (
        <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.5rem' }}>{children}</ul>
    ),
    ol: ({ children }) => (
        <ol style={{ paddingLeft: '1.5rem', marginBottom: '0.5rem' }}>{children}</ol>
    ),
    li: ({ children }) => (
        <li style={{ marginBottom: '0.25rem' }}>{children}</li>
    ),
    p: ({ children }) => (
        <p style={{ marginBottom: '0.5rem' }}>{children}</p>
    ),
    a: ({ href, children }) => (
        <a href={href} style={{ color: '#E9495A', textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    ),
    code: ({ inline, children, ...props }: any) => (
        inline ?
            <code style={{
                backgroundColor: '#f1f1f1',
                padding: '0.2rem 0.4rem',
                borderRadius: '4px',
                fontSize: '0.9rem'
            }} {...props}>{children}</code> :
            <pre style={{
                backgroundColor: '#f1f1f1',
                padding: '1rem',
                borderRadius: '8px',
                overflowX: 'auto',
                fontSize: '0.9rem'
            }}><code {...props}>{children}</code></pre>
    )
}; 